<template>
    <div class="profitBlock-wrap">
        <div class="profitBlock-title">
            Доход
        </div>
        <tabs :classNavigation = "'profitTab'"
            :classItem = "'profitTab-item'"
            :classActive="'profitTab-item-active'">
            <tab :name="'$'" :selected="true">
                <div v-for="(item,index) in profitWidgets" :key="index">
                    <profit-widget  :incomeTitle="item.title"
                    :type="item.type" :chart="item.chart" :param="item.param"></profit-widget>
                </div>
            </tab>
            <tab :name="'%'">
                <profit-percent></profit-percent>
            </tab>
            <tab :name="'P/L'" >
                <calendar></calendar>
            </tab>
        </tabs>
    </div>
</template>
<script>
import ProfitWidget from "./income-widget.vue"
import Tab from "../../../ui-components/ui-tab"
import Tabs from "../../../ui-components/ui-tabs"
import PercentWidget from "./income-percent-block"
import CalendarWidget from "./week-and-month-stat-block"
export default {
    components: {
        'profit-widget':ProfitWidget,
        'tab':Tab,
        'tabs':Tabs,
        'profit-percent':PercentWidget,
        'calendar':CalendarWidget
    },
    data() {
        return {
            profitWidgets:[ {
                title:'Баланс',
                type: 'balance',
                chart: true,
                param: 'bal'
            },
            {
                title:'Средства',
                type: 'equity',
                chart: true,
                param: 'eq'
            },
            {
                title:'Чистая прибыль',
                type:'plAbs',
                chart: true,
                param: 'plAbs'
            },
            {
                title:'Валовая прибыль',
                type:'plGross',
                chart: true,
                param:'bal'
            },
            {
                title:'Текущий доход',
                type:'plCur',
                chart: true,
                param:'plCur'
            },
            {
                title:'Изменения за сутки',
                type:'changeDay',
                chart: true,
                param:'changeDay'
            }
            ],

        }
    }
}
</script>
<style lang="less" scoped>
.profitBlock {
    &-wrap {
        background: #293546;
        margin-top: 8px;
        position: relative;
    }
    &-title {
        font-family: Arimo;
        font-size: 11px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-transform: uppercase;
        line-height: 3.5;
        letter-spacing: 0.4px;
        color: #fff;
        margin-left: 16px;
        position: absolute;
    }
}

</style>

